<template>
  <div>
    <a-table
      size="small"
      :data-source="data"
      :row-key="record=>record.id"
      :pagination="false"
      :columns="columns">
      <template
        slot="url-column"
        slot-scope="url">
        <div class="verification-details-photos__img-wrp">
          <img
            v-auth-image.src="`${url}`"
            @click="selectPhotoUrl"
            class="app__img-preview">
        </div>
      </template>
    </a-table>

    <photo-viewer
      :img-url="selectedDocUrl"
      :is-shown.sync="isImageViewerShown"
    />
  </div>
</template>

<script>
import { globalize } from '@/vue/filters/globalize'
import ATable from 'ant-design-vue/lib/table'
import Country from '@/vue/common/country/Country'
import PhotoViewer from '@/vue/common/PhotoViewer'
/* eslint-disable-next-line */
import TwoColoredStatus from '../two-colored-status'

const columns = ctx => {
  /* eslint-disable-next-line */
    const h = ctx.$createElement
  return [
    {
      dataIndex: 'id',
      key: 'id',
      title: globalize('verification-details-company.lbl-doc-type-id'),
    },
    {
      dataIndex: 'reviewResult',
      key: 'reviewResult',
      title: globalize('user-data.review-result'),
      customRender: (text) => {
        return <TwoColoredStatus value={text} />
      },
    },
    {
      dataIndex: 'country',
      key: 'country',
      title: globalize('user-data.country'),
      customRender: (text) => {
        return <Country code={text}/>
      },
    },
    {
      dataIndex: 'url',
      key: 'url',
      title: 'URL',
      scopedSlots: { customRender: 'url-column' },
    },
  ]
}

export default {
  name: 'beneficiary-docs',
  components: {
    ATable,
    PhotoViewer,
    /* eslint-disable-next-line */
    TwoColoredStatus,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      selectedDocUrl: '',
      isImageViewerShown: false,
    }
  },
  computed: {
    columns () {
      const result = columns(this)

      return result
    },
  },
  methods: {
    selectPhotoUrl (ev) {
      this.selectedDocUrl = ev.target.attributes.src.value
      this.isImageViewerShown = true
    },
  },
}
</script>
